export default "__VITE_ASSET__BhY4ZStv__"